import Vue from 'vue'
import Vuetify from 'vuetify/lib/framework'

Vue.use(Vuetify)

export default new Vuetify({
    theme: {
        light: true,
        themes: {
            light: {
                primary: '#B46EC2',
                secondary: '#C85C8D',
                accent: '#7E5899',
                error: '#C85C8D'
            }
        }
    }
})